import { NavLink } from 'react-router-dom';
import { useT } from '../../../i18n/I18nProvider';
import './system-tabs.css';

/**
 * The five operational destinations, as a tab row on the hub.
 *
 * `/system` has no layout route of its own, so its children are flat siblings
 * and moving between Health and Alerts costs two clicks through the hub. This
 * is the cheap half of that fix: the hub itself offers the five in one row,
 * exactly where the design puts them.
 */
export function SystemTabs() {
  const t = useT();
  const tabs = [
    { to: '/system/health', label: t('system.cards.health.title') },
    { to: '/system/alerts', label: t('system.cards.alerts.title') },
    { to: '/system/backups', label: t('system.cards.backups.title') },
    { to: '/system/security', label: t('system.cards.security.title') },
    { to: '/queue-monitoring', label: t('system.cards.queues.title') }
  ];
  return (
    <nav className="rr-system-tabs" aria-label={t('system.title')}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) => `rr-system-tabs__tab${isActive ? ' rr-system-tabs__tab--active' : ''}`}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
